import React, {Component} from 'react'
import Select from 'react-select'
import {defineMessages, FormattedMessage, injectIntl} from 'react-intl'

const messages = defineMessages({
    'not-interested':{
            id:"quote.declined_reason.not_interested_label",
            defaultMessage:"Not interested by the products"
            },
    'too-expensive':{
            id:"quote.declined_reason.too_expensive_label",
            defaultMessage:"Too expensive"
        },
    'bought-somewhere-else':{
            id:"quote.declined_reason.bought_somewhere_else_label",
            defaultMessage:"Customer bought somewhere else"
        },
    'not-ready-to-buy':{
            id:"quote.declined_reason.not_ready_to_buy_label",
            defaultMessage:"Customer not ready to buy"
        },
    'too-long-delivery-time':{
            id:"quote.declined_reason.too_long_delivery_time_label",
            defaultMessage:"Too long delivery time"
        },
    'made-an-updated-offer':{
            id:"quote.declined_reason.made_an_updated_offer_label",
            defaultMessage:"Made an updated offer"
        },
    'expired':{
            id:"quote.declined_reason.expired_label",
            defaultMessage:"Expired"
        }
   
})

class DeclinedQuoteReason extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            options: [],
            selectedOption: this.props.value,
       
        }

        this.state.options=[
            {value:'not-interested' , label:this.props.intl.formatMessage(messages['not-interested'])},
            {value:'too-expensive' , label:this.props.intl.formatMessage(messages['too-expensive'])},
            {value:'bought-somewhere-else' , label:this.props.intl.formatMessage(messages['bought-somewhere-else'])},
            {value:'not-ready-to-buy' , label:this.props.intl.formatMessage(messages['not-ready-to-buy'])},
            {value:'too-long-delivery-time' , label:this.props.intl.formatMessage(messages['too-long-delivery-time'])},
            {value:'made-an-updated-offer' , label:this.props.intl.formatMessage(messages['made-an-updated-offer'])},
            {value:'expired' , label:this.props.intl.formatMessage(messages['expired'])},
        ]
        const defaultCallback = () => {}
        this.name = this.props.name
        this.multi = this.props.multi || false        
        this.placeholder = this.props.placeholder
        this.onChange = this.props.onChange || defaultCallback

        this.handleChange = this.handleChange.bind(this)
    }

  

    handleChange(selectedOption) {
        this.setState({
            selectedOption: selectedOption
        }, () => {
            let val = ''
            let label=''
            if (this.multi) {
                val = []
            }
            if (selectedOption) {
                if (this.multi) {
                    val = selectedOption.map(option => option.value)
                    label=selectedOption.map(option=> option.label).join(',')
                } else {
                    val = selectedOption.value
                    label= selectedOption.label
                }
            }

            this.onChange(val,label)
        });
    }

    
    componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.value || (this.multi ? [] : '')
        })
    }

    render() {
        return (
            <Select
                multi={this.multi}
                name={this.name}
                placeholder={this.placeholder}
                value={this.state.selectedOption}
                onChange={this.handleChange}
                options={this.state.options}
            />
        )
    }
}

export default injectIntl(DeclinedQuoteReason)





// WEBPACK FOOTER //
// ./src/common/search-filter/others/declinedQuoteReason.component.jsx